module.exports = __webpack_public_path__ + "img/CharlieH.f1ee45b5.jpg";